import { ContactsResolver } from './contacts.resolver';
import { UsersResolver } from './users.resolver';
import { OrderResolver } from './order.resolver';
import { SitesResolver } from './sites.resolver';
import { AddressesResolver } from './addresses.resolver';
import { ClientsResolver } from './clients.resolver';
import { TransportTypesResolver } from './transport-types.resolver';
import { UrgencyLevelsResolver } from './urgency-levels.resolver';
import { VehiclesResolver } from './vehicles/vehicles.resolver';
import { ProductTypesResolver } from './product-types.resolver';
import { ContainersResolver } from './containers.resolver';
import { HolidayGroupsResolver } from './holiday-groups.resolver';
import { SchedulesResolver } from './schedules.resolver';
import { RecurringOrderResolver } from './recurring-order.resolver';
import { WaitingTimesResolver } from './waiting-times.resolver';
import { LotsResolver } from './lots.resolver';

export const resolverProviders = [
  OrderResolver,
  SitesResolver,
  AddressesResolver,
  ClientsResolver,
  TransportTypesResolver,
  UrgencyLevelsResolver,
  LotsResolver,
  VehiclesResolver,
  ProductTypesResolver,
  ContainersResolver,
  HolidayGroupsResolver,
  ContactsResolver,
  SchedulesResolver,
  RecurringOrderResolver,
  WaitingTimesResolver,
];
